import * as React from "react";
import { connect } from "react-redux";
import api from "src/api";
import {
  isCreditLensFeatureEnabled,
  isDbsJwtLoginEnabled
} from "src/configState/selector";
import selectorsToProps from "src/utils/selectorsToProps";
import {
  appendTagArea,
  saveTagArea,
  SaveTagAreaActionType
} from "../chartOfAccounts/Tag/actions";
import { getTagConfig, getTagMode } from "../chartOfAccounts/Tag/selector";
import { getSpreadId } from "../model/spread/selector";
import { SpreadGroundPage } from "../model/spread/types";

import Annotation from "react-image-annotation";
import {
  TagAnnotation,
  TagArea,
  TagConfig
} from "../chartOfAccounts/Tag/types";

import {
  Magnifier,
  MOUSE_ACTIVATION,
  TOUCH_ACTIVATION
} from "react-image-magnifiers";

interface SpreadImageProps {
  isCreditLensFeatureEnabled: boolean;
  isDbsJwtLoginEnabled: boolean;
  groundPage: SpreadGroundPage;
  spreadId: string;
  englishTranslationOn?: boolean;
  magnificationOn?: boolean;
  useTranslatedImage?: boolean;
  tagMode: boolean;
  appendTagArea: typeof appendTagArea;
  tagConfig: TagConfig;
  saveTagArea: SaveTagAreaActionType;
  hidden?: boolean;
}

interface SpreadImageState {
  image: string;
  annotations: [];
  annotation: Annotation;
}

export class SpreadImage extends React.PureComponent<
  SpreadImageProps,
  SpreadImageState
> {
  constructor(props: SpreadImageProps) {
    super(props);
    this.state = {
      image: "",
      annotations: [],
      annotation: {} as TagAnnotation
    };
  }
  public async componentDidMount() {
    const url = this.props.useTranslatedImage
      ? this.props.groundPage.translatedImageUrl
      : this.props.groundPage.imageUrl;

    const image = await api.image.get(
      url,
      this.props.isCreditLensFeatureEnabled,
      this.props.spreadId,
      this.props.isDbsJwtLoginEnabled
    );
    this.setState({ image });
  }

  public onChange = annotation => {
    this.setState({ annotation });
  };

  public onMouseUp = () => {
    if (!this.state.annotation || !this.state.annotation.geometry) {
      return this.setState({ annotation: {} });
    }
    const { width, height, x, y } = this.state.annotation.geometry;

    if (
      this.props.tagConfig.parentNodeId &&
      this.props.tagConfig.activeAreaId
    ) {
      const area = {
        width,
        height,
        left: x,
        top: y,
        spreadId: this.props.spreadId,
        pageNumber: this.props.groundPage.pageNumber,
        areaId: this.props.tagConfig.activeAreaId,
        value: ""
      } as TagArea;

      this.props.appendTagArea(area);
      this.props.saveTagArea(area);
    }

    this.setState({ annotation: {} });
  };

  public render() {
    const image = this.props.tagMode ? (
      <Annotation
        className="SpreadPage__image"
        src={this.state.image}
        alt={`${this.props.groundPage.pageNumber}`}
        annotations={this.state.annotations}
        value={this.state.annotation}
        onChange={this.onChange}
        onMouseUp={this.onMouseUp}
        disableEditor={true}
      />
    ) : (
      <>
        {this.props.magnificationOn && !this.props.hidden && (
          <Magnifier
            imageSrc={this.state.image}
            dragToMove={true}
            mouseActivation={MOUSE_ACTIVATION.CLICK}
            touchActivation={TOUCH_ACTIVATION.CLICK}
          />
        )}
        {!this.props.magnificationOn && (
          <img
            src={this.state.image}
            alt={`${this.props.groundPage.pageNumber}`}
            className="SpreadPage__image"
          />
        )}
      </>
    );

    return this.state.image && this.isVisible()
      ? image
      : !this.props.useTranslatedImage && (
          <div className="SpreadPage__image">
            {this.props.groundPage.pageNumber}
          </div>
        );
  }

  private isVisible = () => {
    return (
      (!this.props.useTranslatedImage && !this.props.englishTranslationOn) ||
      (this.props.useTranslatedImage && this.props.englishTranslationOn)
    );
  };
}

export default connect(
  selectorsToProps({
    isCreditLensFeatureEnabled,
    spreadId: getSpreadId,
    isDbsJwtLoginEnabled,
    tagMode: getTagMode,
    tagConfig: getTagConfig
  }),
  {
    appendTagArea,
    saveTagArea: saveTagArea.action
  }
)(SpreadImage);



// WEBPACK FOOTER //
// ./src/spread/rawSpread/SpreadImage.tsx